// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "Onboarding__textCenter__UAQjc";
export const onboarding = "Onboarding__onboarding__pDvSu";
export const wider = "Onboarding__wider__AFo0w";
export const content = "Onboarding__content__EHui+";
export const profileCompact = "Onboarding__profileCompact__BdLYk";
export const main = "Onboarding__main__Le6Fu";